import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import Dropdown from 'core/dropdown';
import { mediumTopShadow } from 'ui/theme';
import { DockingBar, NumberInput } from '@iterable/deprecated_react_components';

export const LimitAndOrderByRowContainer = styled.div`
  background: #fcfcfc; /** css file conversion */
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1 1 auto;
  gap: ${pxToRem(10)};
  padding: ${pxToRem(5)} 0 ${pxToRem(10)} 0;
  > *:last-child {
    margin-left: auto;
  }
`;

export const StyledCoreDockingBar = styled(DockingBar)`
  &&&& {
    width: 100%;
    margin-top: ${pxToRem(20)}; /** css file conversion */
    &.cssLimitAndOrderDocked {
      border-top: ${pxToRem(2)} solid rgba(0, 0, 0, 0.15); /** css file conversion */
      left: 0;
      ${mediumTopShadow}
    }
  }
`;

export const StyledNumberInput = styled(NumberInput)`
  && {
    height: ${pxToRem(36)}; /** css file conversion */
    width: ${pxToRem(120)}; /** css file conversion */
  }
`;

export const FlexContainer = styled.div<{ maxWidth?: number }>`
  display: flex;
  height: ${pxToRem(61)};
  flex-direction: column;
  max-width: ${({ maxWidth }) => (maxWidth ? `${pxToRem(maxWidth)}` : 'unset')};
`;

export const InputContainer = styled.div`
  display: flex;
  flex: 1;
  &&& .cssOrderByInputFieldDropdownInput {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    margin-bottom: 0;
  }
`;

export const StyledCoreDropdown = styled(Dropdown)`
  &&&& {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: ${pxToRem(36)}; /** css file conversion */
    margin-left: -${pxToRem(1)}; /** css file conversion */
    min-width: ${pxToRem(70)}; /** css file conversion */
    width: ${pxToRem(70)}; /** css file conversion */
    .visible.menu {
      width: ${pxToRem(170)};
    }
  }
`;
